import { render, staticRenderFns } from "./SpeciesTeaser.vue?vue&type=template&id=550908bb&scoped=true&"
import script from "./SpeciesTeaser.vue?vue&type=script&lang=js&"
export * from "./SpeciesTeaser.vue?vue&type=script&lang=js&"
import style0 from "./SpeciesTeaser.vue?vue&type=style&index=0&id=550908bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550908bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('550908bb')) {
      api.createRecord('550908bb', component.options)
    } else {
      api.reload('550908bb', component.options)
    }
    module.hot.accept("./SpeciesTeaser.vue?vue&type=template&id=550908bb&scoped=true&", function () {
      api.rerender('550908bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/gallery/SpeciesTeaser.vue"
export default component.exports